import { ajax } from "./ajax";
import * as es6promise from "es6-promise";
import { Logger } from "./logger";
import { retailerConfigEntity } from "../entity/retailerConfigEntity";

// GIGYA
declare var gigya: any;

// WebKit
interface Window {
	webkit?: any;
	location?: any;
}
declare var window: Window;

export module SSO {

	// WebAPIのエンドポイント定義
	const WebAPI_OCAPISSO = "Login/OCAPISSO/";
	const WebAPI_GIGYASSO = "Login/GIGYA/";
	const WebAPI_LoginCheck = "Login/Check";

	// リテーラconf
	let _retailerConf: retailerConfigEntity;

	// gigyaのコールバック後で使用する認証トークン(退避)
	let _tkn: string;

	let isDebug = false;
	const devUrl = ["localhost", "127.0.0.1","ff-posca"];

	/**
	 * 初期化処理
	 * */
	export function init() {

		const current = window.location.href;
		let rt = devUrl.filter(url => {
			return current.indexOf(url) > 0;
		});
		if (rt.length > 0) {
			isDebug = true;
		}

	}

	// ---------- 外向け -------------------------------------------

	/**
	 * SSO処理が完了したかの判定フラグ
	 * ※GIGYAがawaitできないため、これで対応。
	 * */
	export let SSOCopmlete = false;

	/**
	 * パラメータセット
	 * @param ccgigya
	 * @param cclogincheck
	 * @param clientId
	 */
	export function SetRetailerSetting(conf: retailerConfigEntity) {
		_retailerConf = conf
	}

	/**
	 * SSOの処理を行う。
	 * @param token
	 * @param editId
	 */
	export async function DoSSO(token: string,retailerId:string) {

		SSOCopmlete = false;

		if (retailerId == "0") {
			Logger.log("SSO FF");
			await GIGYASSOMain(token);
		} else {
			Logger.log("SSO OCAPI");
			await OCAPISSOMain(token);
        }

	}

	/**
	 * SSO連携の結果を待つ。
	 * */
	export async function WaitSSO(): es6promise.Promise <void> {
		function sleep(ms) {
			return new Promise(resolve => setTimeout(resolve, ms));
		}

		// 10回まっても結果が返ってこなければSSO中断する。
		for (let i = 0; i < 10; i++) {
			Logger.info("SSO連携待ち中...", i);
			if (!SSO.SSOCopmlete) {
				await sleep(500);
			} else {
				return;
			}
		}
		Logger.info("SSO.SSOCopmlete", SSO.SSOCopmlete);
		return;
	}

// #region GIGYA

	/**
	 * GIGYAでSSOメインロジック
	 * @param token
	 */
	async function GIGYASSOMain(token: string) {

		_tkn = token;

		// まずはGIGYAのログインチェック	
		Logger.log(`gigyaLoginResult start: token => ${_tkn}`);
		let gigyaLoginResult = await GIGYALoginCheck(token);
		Logger.log("gigyaLoginResult end", gigyaLoginResult);
		if (gigyaLoginResult) {

			// GIGYAログイン済み、次はポスカのログインチェック
			let poscaLoginResult = await LoginCheck(token);
			if (!poscaLoginResult) {

				// UID,UIDSignature,timestampを取得してその後の処理も行う。
				// GIGYAはawaitできないので突き出しにしておく。
				GIGYAGetUID();
				Logger.log("SSO連携突き出し開始");

			} else {
				SSOCopmlete = true;
				Logger.log("GIGYA,ポスカ ログイン済み");
			}

		} else {
			// GIGYAは未ログインなのでSSOは実施しない。
			SSOCopmlete = true;
			Logger.log("GIGYA未ログイン");
		}
	}

	/**
	 * GIGYAからUID等を取ってくる。
	 * */
	function GIGYAGetUID(): void {
		Logger.log("GIGYAGetUID");
		gigya.accounts.getAccountInfo({
			include: "identities-all",
			callback: CallBackGetAccountInfo
		})
    }

	/**
	 * GIGYAからUID取ってきた際にコールバックされるもの
	 * @param res
	 */
	async function CallBackGetAccountInfo(res): es6promise.Promise<any> {
		Logger.log("CallBackGetAccountInfo");
		if (res.errorCode == 0) {
			let uid = res['UID'];
			let uidSignature = res['UIDSignature'];
			let signatureTimestamp = res['signatureTimestamp'];
			Logger.log("uid",uid);
			Logger.log("uidSignature", uidSignature);
			Logger.log("signatureTimestamp", signatureTimestamp);

			// GIGYA SSO連携をする。
			Logger.log("GIGYAログイン済み、ポスカ未ログイン");
			let ssoResult = await GIGYASSO(_tkn, uid, uidSignature,signatureTimestamp);
			if (!ssoResult) {
				Logger.log("SSO失敗...");
			}
			Logger.log("SSOでログインしました。");
			SSOCopmlete = true;
			return true;
		}
		else {
			Logger.log('Error :' + res.errorMessage);
			Logger.log('res   :' + res.errorCode);
			SSOCopmlete = true;
			return;
		}   
    }

	/**
	 * GIGYA ポスカ側で未ログインなのでGIGYAログインする。
	 * @param token
	 */
	async function GIGYASSO(token: string, UID: string, UIDSignature: string,timestamp): es6promise.Promise<any> {
		if (isDebug) {
			return true;
		}

		let req = {
			token: token,
			uid: UID,
			signature: UIDSignature,
			sigtimestamp:timestamp
		}
		return await ajax.post(WebAPI_GIGYASSO, JSON.stringify(req)).then((data) => {
			// SSO OK!
			Logger.log("GIGYAログインしました");
			return true;
		}).catch((e) => {
			throw e;
		});
	}

	/**
	 * ログインチェックを行います。(GIGYA)
	 * 未ログイン時はfalse
	 */
	export async function GIGYALoginCheck(tkn: string): es6promise.Promise<any> {
		if (isDebug) {
			return true;
		}

		// GIGYA側のログインチェック
		return await ajax.getForCCLoginCheck(_retailerConf.extrSettings.ocapi.ocapiLoginCheckURL).then((res: string) => {
			return res.toLocaleLowerCase() == "true" ? true : false;
		}).catch((e) => {
			throw e;
		});
	}
// #endregion

// #region OCAPI
	/**
	 * OCAPIでSSOメインロジック
	 * @param token
	 */
	async function OCAPISSOMain(token: string) {

		// まずはSFCCのログインチェック
		let ocapiLoginResult = await OCAPIAccountLoginCheck();
		if (ocapiLoginResult.responseStatus) {

			// SFCCログイン済み、次はポスカのログインチェック
			let poscaLoginResult = await LoginCheck(token);
			if (!poscaLoginResult) {

				// ポスカは未ログインなのでSSO連携をする。
				Logger.log("OCAPIログイン済み、ポスカ未ログイン");
				let ssoResult = await OCAPISSO(token, ocapiLoginResult.authorization, ocapiLoginResult.customerId);
				if (!ssoResult) {
					Logger.log("SSO失敗...");
				}
				Logger.log("SSOでログインしました。");

			} else {
				Logger.log("OCAPI,ポスカ ログイン済み");
            }

		} else {
			// OCAPIは未ログインなのでSSOは実施しない。
			Logger.log("OCAPI未ログイン");
		}
		SSOCopmlete = true;
    }

	/**
	 * SFCC側でログインしているかチェックする
	 * @param token
	 */
	async function OCAPIAccountLoginCheck(): es6promise.Promise<any> {
		if (isDebug) {
			return {
				responseStatus: true,
				customerId: "abdUL0YcdwSm0MSI5abkEeA2Rc",
				authorization: "Bearer eyJfdiI6IjEiLCJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfdiI6IjEiLCJleHAiOjE2NTc2NzkxMzcsImlhdCI6MTY1NzY3NzMzNywiaXNzIjoiYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhIiwic3ViIjoie1wiX3ZcIjpcIjFcIixcImN1c3RvbWVyX2luZm9cIjp7XCJjdXN0b21lcl9pZFwiOlwiYWJkVUwwWWNkd1NtME1TSTVhYmtFZUEyUmNcIixcImd1ZXN0XCI6ZmFsc2UsXCJ2aXNpdF9pZFwiOlwiYjc3NWExNzU4NDYwN2MzNGQ0MjI3NTk3OTRcIn19In0.dl8XgldAVo8SGRDrrSAdnbD_tnRnfYwIrohjhsPW78JgTif2kukQqnB74RgKHRx6U5CTBee8ktTVwqnmtguRT0zTaqQy6FzB2GQUjJaNZc03kEXDAJ2QyAkkKBY2MQEeIH-a6xjsDKM0bYtl4Df7JOQI38pvTfH4j3oaucbjiNjwkUGCPs_LS_JYaTNhkdqjlRDBcyYo3h8ArKx_5YJK18aynZ00coTdezBKLTzMb7ByQTjiYk7tOi-7SSgrri89gY8EIYV9uqACQCuRVCbuc1GYu0OFr_RipfeglkIeO9tSFneyECtAPQ_Ly1PDNzHvf8-2Uoh-_kKR3dP4Y0Nof1oo_vPiKyQA83_s7h5fGPC9okARuuH2_pOzYA0DKp4RJBvyCc1bmVg_pZYDSOyFHaNhcOWCCjm6-mOy29IGdasKKRuDlWzO8rfYLR5wEOu2xrFgbFaCjmXmLZeoWvuPl_9LeOITgx0tlcyIluArvQwnOMoL1IYqgTVDHCQhtFw1n5EzYg8-rFjqQ8e4XG0cQ-tC8PNmdbXCBwIDQkKP2HNQ5X4rHLknq7cKBXbBTUun"
			};
		}
		return await ajax.get(_retailerConf.extrSettings.ocapi.accountLoginCheckURL,"").then((data) => {
			Logger.debug("AccountLoginCheck()", data);
			return data;
		}).catch((e) => {
			throw e;
		});
	}
	/**
	 * OCAPI ポスカ側で未ログインなのでSSOする。
	 * @param token
	 */
	async function OCAPISSO(token: string,jwt:string,customerId:string): es6promise.Promise<any> {
		if (isDebug) {
			return true;
		}

		let req = {
			token: token,
			jwt: jwt,
			customerId:customerId
		}
		return await ajax.post(WebAPI_OCAPISSO, JSON.stringify(req)).then((data) => {
			if (data.isLogind)
				// SSO OK!
				return true;
			else
				// SSO NG...
				return false;
		});
	}
	/**
	 * OCAPI ポスカ側のログインチェックをする。
	 * @param token
	 */
	async function LoginCheck(token: string): es6promise.Promise<any> {
		if (isDebug) {
			return true;
		}

		let req = {
			token: token,
		}
		return await ajax.post(WebAPI_LoginCheck, JSON.stringify(req)).then((data) => {
			if (data.isLogind)
				// PoscaLogin OK!
				return true;
			else
				// PoscaLogin NG...
				return false;
		});
	}
// #endregion OCAPI
}